'use client';
import useFeature from './useFeature';
import { Entry } from 'contentful';
import { useState, useEffect } from 'react';
import { TypeLaunchDarklyVariationContainerFields } from '../core/generated-types';
import { FeatureFlagValues } from '../core/featureFlags';

export default function useFeatureContent({
  variations = [],
  featureFlagKey = '',
  meta,
}: TypeLaunchDarklyVariationContainerFields) {
  const decision = useFeature(featureFlagKey as keyof FeatureFlagValues);
  const variation = decision || 'default';
  const [content, setContent] = useState<
    Entry<Record<string, any>> | undefined
  >(undefined);

  useEffect(() => {
    const variationKey = meta[variation as string];

    setContent(
      variations.find((componentVariation: Entry<Record<string, any>>) => {
        return componentVariation?.sys?.id === variationKey;
      }),
    );
  }, [featureFlagKey, meta, variation, variations]);

  return content;
}
